const protocol='https';
const host='testadmin.cropwork.in'

const port=''
const trailUrl=''

const hostUrl=`${protocol}://${host}${port?':'+port:''}`;
const endpoint=`${protocol}://${host}${port?':'+port:''}${trailUrl}`;

export default{
    protocol:protocol,
    host:host,
    port:port,
    trailUrl:trailUrl,
    hostUrl:hostUrl,
    endpoint:endpoint
}